import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Swallow benign ResizeObserver warnings triggered by Radix UI (Select/Dialog)
// so CRA's dev-error overlay doesn't intercept clicks in the preview.
const RESIZE_MSG = "ResizeObserver loop";
window.addEventListener("error", (e) => {
  if (e?.message?.includes(RESIZE_MSG)) {
    e.stopImmediatePropagation();
  }
});
window.addEventListener("unhandledrejection", (e) => {
  if (String(e?.reason?.message || "").includes(RESIZE_MSG)) {
    e.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
